export const sharedInitialValues = (initialValues) => ({
    personalInformation: {
        name: initialValues.first_name || '',
        surname: initialValues.last_name || '',
        email: initialValues.email || '',
        phone: initialValues.phone || '',
        address: initialValues.address_1 || '',
        houseNumber: initialValues.address_2 || '',
        city: initialValues.city || '',
        zipCode: initialValues.postcode || '',
    },
});
